export const EmailAutomationTimeframes = {
  DaysBefore: 'days_before',
  DaysAfter: 'days_after',
  OnDayOf: 'on_day_of'
};

export const EmailAutomationTriggers = { PolicyExpiration: 'policy_expired' };
